import { render } from "./UploadError.vue?vue&type=template&id=2d57daea&scoped=true"
import script from "./UploadError.vue?vue&type=script&lang=js"
export * from "./UploadError.vue?vue&type=script&lang=js"

import "./UploadError.vue?vue&type=style&index=0&id=2d57daea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d57daea"]])

export default __exports__